import { Typography } from 'antd';
import { styled } from 'styled-components';
import { blockStyle } from '../styles/Block';

const { Title: AntTitle, Text } = Typography;

export const TitleBlock = styled.div`
  ${blockStyle}
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: auto;
`;

export const TitleText = styled(AntTitle).attrs({ level: 4 })`
  && {
    color: rgba(0, 0, 0, 0.88);
    margin: 0;
  }
`;

export const SubTitleText = styled(Text)`
  color: rgba(0, 0, 0, 0.65);
`;
